interface BrokerTypeInfo {
  id: number;
  label: string;
}

export enum BrokerType {
  Tradernet,
  Freedom,
  Tinkoff,
  Finam,
  PE,
  Crypto,
  Arbitr,
  Binance,
  CryptoDeposit,
  NVB,
  PrimeIPO,
  IPO,
}

export const brokerTypes = [
  BrokerType.Tradernet,
  BrokerType.Binance,
  BrokerType.Freedom,
  BrokerType.Tinkoff,
  BrokerType.Finam,
];

export enum FreedomType {
  global,
  armenia,
  turlov,
}

export const freedomTypes = [
  FreedomType.global,
  FreedomType.armenia,
  FreedomType.turlov,
];

export const brokerTypesData: Record<BrokerType, BrokerTypeInfo> = {
  [BrokerType.Tradernet]: { id: 1, label: 'tradernet' },
  [BrokerType.Freedom]: { id: 1, label: 'freedom' },
  [BrokerType.Tinkoff]: { id: 2, label: 'tinkoff' },
  [BrokerType.PE]: { id: 3, label: 'pe' },
  [BrokerType.Finam]: { id: 4, label: 'finam' },
  [BrokerType.Crypto]: { id: 5, label: 'crypto' },
  [BrokerType.Arbitr]: { id: 6, label: 'arbitr' },
  [BrokerType.Binance]: { id: 7, label: 'binance' },
  [BrokerType.CryptoDeposit]: { id: 8, label: 'cryptoDeposit' },
  [BrokerType.NVB]: { id: 9, label: 'nvb' },
  [BrokerType.PrimeIPO]: { id: 10, label: 'primeIpo' },
  [BrokerType.IPO]: { id: 11, label: 'ipo' },
};
